export const typeMap = {
  experience: '免费体验', // 首页免费体验
  try: '申请试用', // 首页开始试用 产品详情页申请试用
  cooperation: '合作咨询', // 首页成为合作伙伴
  business: '业务咨询', // 解决方案页立即咨询
};

export const defaultConsultOptions = [
  {
    fieldKey: 'priority',
    fieldName: '优先级',
    fieldType: 'DROP_DOWN_SINGLE',
    required: true,
    fieldItemModels: [
      {
        itemName: '最高优',
        itemValue: '63',
      },
      {
        itemName: '高优',
        itemValue: '64',
      },
      {
        itemName: '中等',
        itemValue: '65',
      },
      {
        itemName: '较低',
        itemValue: '66',
      },
      {
        itemName: '极低',
        itemValue: '67',
      },
    ],
  },
  {
    fieldKey: 'F24370',
    fieldName: '所在行业',
    fieldType: 'RADIO',
    required: false,
    fieldItemModels: [
      {
        itemName: '泛娱乐',
        itemValue: '173774',
      },
      {
        itemName: '教育',
        itemValue: '173775',
      },
      {
        itemName: '电商',
        itemValue: '173776',
      },
      {
        itemName: '广电/传媒',
        itemValue: '173777',
      },
      {
        itemName: '政企',
        itemValue: '173778',
      },
      {
        itemName: '社交',
        itemValue: '173779',
      },
      {
        itemName: '游戏',
        itemValue: '173780',
      },
      {
        itemName: 'IoT',
        itemValue: '173781',
      },
      {
        itemName: '其他',
        itemValue: '173782',
      },
    ],
  },
  {
    fieldKey: 'F24371',
    fieldName: '业务类型',
    fieldType: 'CHECKBOX',
    required: false,
    fieldItemModels: [
      {
        itemName: '短视频',
        itemValue: '173783',
      },
      {
        itemName: '长视频',
        itemValue: '173784',
      },
      {
        itemName: '直播',
        itemValue: '173785',
      },
      {
        itemName: '实时音视频',
        itemValue: '173786',
      },
      {
        itemName: '视频压缩',
        itemValue: '173787',
      },
      {
        itemName: '视频修复&增强',
        itemValue: '173788',
      },
      {
        itemName: 'CDN',
        itemValue: '173789',
      },
      {
        itemName: '视频AI',
        itemValue: '173790',
      },
      {
        itemName: '图片AI',
        itemValue: '173791',
      },
      {
        itemName: '其他',
        itemValue: '173792',
      },
    ],
  },
];

export const defaultFeedbackOptions = [
  {
    fieldKey: 'priority',
    fieldName: '优先级',
    fieldType: 'DROP_DOWN_SINGLE',
    required: true,
    fieldItemModels: [
      {
        itemName: '最高优',
        itemValue: '63',
      },
      {
        itemName: '高优',
        itemValue: '64',
      },
      {
        itemName: '中等',
        itemValue: '65',
      },
      {
        itemName: '较低',
        itemValue: '66',
      },
      {
        itemName: '极低',
        itemValue: '67',
      },
    ],
  },
  {
    fieldKey: 'F24383',
    fieldName: '建议类型',
    fieldType: 'RADIO',
    required: false,
    fieldItemModels: [
      {
        itemName: '产品建议',
        itemValue: '173811',
      },
      {
        itemName: '功能缺陷',
        itemValue: '173812',
      },
      {
        itemName: '文档建议',
        itemValue: '173813',
      },
      {
        itemName: 'BUG反馈',
        itemValue: '173814',
      },
      {
        itemName: '其他建议',
        itemValue: '173815',
      },
    ],
  },
];

export const defaultCmsConfig = {
  hotSearchKeys: ['点播云', '直播云', '访问控制', '密钥', '实时音视频'],
  productTypeOrder: [
    '新手必看',
    'StreamLake-Video',
    'StreamLake-AI',
    '支持与服务',
  ],
};
